import { ReceiptTokenFeeInfo, SupportedTokenName } from "@mezo/sdk"
import { createSlice } from "@reduxjs/toolkit"

import { DepositFeeData } from "#/shared/utils"

type ReceiptTokenState = {
  feeInfo: Partial<Record<SupportedTokenName, ReceiptTokenFeeInfo | null>>
  depositFeeData: DepositFeeData & { maxMintAmount: bigint }
  maxPossibleTotalMintAmount: bigint
}

const initialState: ReceiptTokenState = {
  feeInfo: {
    WBTC: null,
    tBTC: null,
  },
  depositFeeData: {
    depositId: null,
    feeOwed: 0n,
    lastFeeIntegral: 0n,
    maxMintAmount: 0n,
  },
  maxPossibleTotalMintAmount: 0n,
}

const receiptTokenSlice = createSlice({
  name: "receipt-token",
  initialState,
  reducers: {
    setFeeInfo: (
      immerState,
      {
        payload,
      }: {
        payload: { token: SupportedTokenName; feeInfo: ReceiptTokenFeeInfo }
      },
    ) => {
      immerState.feeInfo[payload.token] = payload.feeInfo
    },
    setDepositFeeData: (
      immerState,
      { payload }: { payload: DepositFeeData },
    ) => {
      immerState.depositFeeData = { ...immerState.depositFeeData, ...payload }
    },
    setMaxMintAmount: (immerState, { payload }: { payload: bigint }) => {
      immerState.depositFeeData.maxMintAmount = payload
    },
    setMaxPossibleTotalMintAmount: (
      immerState,
      { payload }: { payload: bigint },
    ) => {
      immerState.maxPossibleTotalMintAmount = payload
    },
    resetDepositFeeDataState: (immerState) => {
      immerState.depositFeeData = initialState.depositFeeData
    },
  },
})

export const {
  setFeeInfo,
  setDepositFeeData,
  setMaxMintAmount,
  setMaxPossibleTotalMintAmount,
  resetDepositFeeDataState,
} = receiptTokenSlice.actions

export default receiptTokenSlice.reducer
